import { isApiServerError } from '@cp/utils/apiServer/errorHandler';
import { HttpStatusCode } from '@cp/utils/const/httpStatusCode';
import { promocodeApi } from '@cp/entities/promocode';
import { useCallback } from 'react';
import { Result } from '@cp/shared/result';
import { PromocodeViewModel } from '@common/model/billing/promocode';
import { SerializedError } from '@reduxjs/toolkit';
import { PromoCodeFormModel } from 'src/entities/promo';

export type ActivatePromocodeFeature = (v: PromoCodeFormModel) => Promise<Result<PromocodeViewModel, SerializedError>>;

export const useActivatePromocode = (): ActivatePromocodeFeature => {
  const [activatePromocode] = promocodeApi.endpoints.activatePromocode.useMutation();

  return useCallback<ActivatePromocodeFeature>(
    async (values) => {
      const response = await activatePromocode(values);
      if ('error' in response) {
        const commonError =
          isApiServerError(response.error) &&
          [HttpStatusCode.NotFound, HttpStatusCode.BadRequest, HttpStatusCode.UnprocessableEntity].includes(response.error.status);
        return Result.Err(commonError ? new Error('Промокод не может быть активирован') : response.error);
      } else {
        return Result.Ok(response.data);
      }
    },
    [activatePromocode],
  );
};
